import React, { Component } from 'react'
import { connect } from 'react-redux';
import { Field, formValueSelector, reduxForm } from 'redux-form';
import { renderFieldSelect, required, requiredSelect } from '../../util/inputs';
import { renderField } from '../../util/arraysUtil';
import transmitirCte from '../../actions/encomenda/transmitirCte';
import { showSuccessMsg } from '../../util/messagesUtil';
import $ from 'jquery';

export class ModalTransmitirCte extends Component {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.limparFormulario = this.limparFormulario.bind(this);

        this.state = {
            naturezaOperacao: null,
            tipoServico: null

        }
    }

    fecharModal() {
        $('#modalTransmitirCte')
            .modal('hide');
        $('#modalTransmitirCte')
            .hide();
        $('.modal-backdrop')
            .hide();
        this.limparFormulario();
    }

    limparFormulario() {
        this.setState({
            naturezaOperacao: null,
            tipoServico: null
        })
        this.props.reset('formularioTransmitirCte');
    }

    handleSelecionarTipoServico(e) {
        this.setState({
            tipoServico: e
        })
    }

    handleSelecionarNatureza(e) {
        this.setState({
            naturezaOperacao: e
        })
    }

    montarParametros() {
        return {
            encomendaId: this.props.encomenda.id,
            empresaId: this.props.empresaSelecionada.id,
            naturezaOperacao: this.state.naturezaOperacao && this.state.naturezaOperacao.value ? this.state.naturezaOperacao.value : this.props.encomenda.naturezaOperacao,
            tipoServicoCte: this.state.tipoServico && this.state.tipoServico.value ? this.state.tipoServico.value : this.props.encomenda.tipoServicoCte.chave,
            rntrc: this.props.rntrc ? this.props.rntrc : this.props.encomenda.rntrc,
            chaveNfe: this.props.chaveNfe ? this.props.chaveNfe : this.props.encomenda.chaveNfe
        }
    }

    submit() {
        this.props.transmitirCte(this.montarParametros())
            .then(() => {
                showSuccessMsg('Foi iniciado a transmissão do ct-e!');
                this.props.buscarPedidos();
                this.fecharModal();
            })
    }

    formulario() {
        const {
            handleSubmit, submitting, invalid, pristine
        } = this.props;
        return (
            <form onSubmit={handleSubmit(this.submit)}>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name='tipoServicoCte'
                            options={this.props.tiposServicos.map(elemento => ({
                                descricao: elemento.valor,
                                nome: elemento.chave
                            }))}
                            onChange={(e) => this.handleSelecionarTipoServico(e)}
                            component={renderFieldSelect}
                            label='Tipo Serviço:'
                            placeholder='Selecione...' validate={requiredSelect}
                        />
                    </div>
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="rntrc" type="text" validate={[required]} component={renderField}
                            label="RNTRC:"
                            css="form-control"
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-12 col-md-12">
                        <Field name='naturezaOperacao'
                            options={this.props.naturezasOperacoes.map(it => ({
                                descricao: it.valor,
                                nome: it.chave
                            }))}
                            component={renderFieldSelect}
                            label="Natureza da Operação:"
                            placeholder='Selecione...' validate={requiredSelect}
                            onChange={(e) => this.handleSelecionarNatureza(e)}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className="col-12 col-sm-6 col-md-6">
                        <Field name="chaveNfe" type="text" validate={[required]} component={renderField}
                            label="Chave NF-e:"
                            css="form-control"
                        />
                    </div>
                </div>
                <div className="modal-footer">
                    <button type="submit" disabled={invalid || submitting || pristine}
                        className="btn btn-laranja">Transmitir
                    </button>
                </div>
            </form>
        )
    }

    render() {
        return (
            <div className="modal fade show" id='modalTransmitirCte' role='dialog'
                aria-labelledby='modalTransmitirCte' aria-hidden='true' data-backdrop='static'>
                <div className={'modal-dialog modal-dialog-centered modal-lg'}>
                    <div className="modal-content">
                        <div className="modal-header">
                            <h3>Transmissão Cte</h3>
                            <button type="button" className="close" data-dismiss="modal" aria-label="Close"
                                onClick={this.limparFormulario}>
                                <i className="material-icons">
                                    close
                                </i>
                            </button>
                        </div>
                        <div className="modal-body">
                            {this.formulario()}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export function mapStateToProps(state) {
    return {
        encomenda: state.encomenda,
        empresaSelecionada: state.empresaSelecionada,
        tiposServicos: state.opcoesFiltrosEmissaoesCte.tipoServicoCte,
        naturezasOperacoes: state.opcoesFiltrosEmissaoesCte.naturezasOperacoes,
        usuarioVendeEncomendaComCte: state.usuarioVendeEncomendaComCte,
        rntrc: formValueSelector('formularioTransmitirCte')(state, 'rntrc'),
        chaveNfe: formValueSelector('formularioTransmitirCte')(state, 'chaveNfe'),
    }
}

export default connect(mapStateToProps, {
    transmitirCte
})(reduxForm({
    form: 'formularioTransmitirCte'
})(ModalTransmitirCte));